module.exports = __webpack_public_path__ + "mo/img/swiper_bg02.4dbf738e.png";